import * as React from 'react'
import { IErrorState } from "../reducers/appReducers"
import { useSelector } from 'react-redux'
import DOMPurify from "dompurify";
import * as AppTypes from "AppTypes"

import "../components/serviceError.scss"

const Error: React.FC = () => {

    const { viewState = {} } = useSelector((store: AppTypes.ReducerState) => ({
        viewState: store.app.viewState as IErrorState
    }))
    const { title, content } = viewState

    return (
        <div className="content app-service-error">
            <div className="app-service-error__icon"></div>
            <h2>{title || "This service is currently unavailable."}</h2>
            {<p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize( !!content ? content : "Our team is working hard to fix this." )}} />}
        </div>
    )
}

export default Error